export const textSizes = [
  {
    title: 20,
    text: 14,
  },
  {
    title: 20,
    text: 14,
  },
  {
    title: 17,
    text: 12,
  },
  {
    title: 17,
    text: 12,
  },
  {
    title: 17,
    text: 12,
  },
];

export const formSize = [
  {
    infoWidth: 370,
    width: 745,
    height: 713,
    fieldHeight: 40,
  },
  {
    infoWidth: 370,
    width: 745,
    height: 713,
    fieldHeight: 40,
  },
  {
    infoWidth: 314,
    width: 634,
    height: 607,
    fieldHeight: 35,
  },
  {
    infoWidth: 314,
    width: 634,
    height: 607,
    fieldHeight: 35,
  },
  {
    infoWidth: 314,
    width: 634,
    height: 607,
    fieldHeight: 35,
  },
];

export const formTextSizes = [
  {
    contactItem: 13,
  },
  {
    contactItem: 13,
  },
  {
    contactItem: 11,
  },
  {
    contactItem: 11,
  },
  {
    contactItem: 11,
  },
];
